document.addEventListener('page:loaded', function() {
  let elements = document.querySelectorAll('.tabs-nav a');
  Array.from(elements).forEach(function(element) {
    element.addEventListener('click', function(event){
      event.preventDefault();
      let liElements = event.target.parentElement.parentElement.parentElement.parentElement.querySelectorAll('.tabs-nav li');
      [].forEach.call(liElements, function(el) {
      	el.classList.remove("tab-active");
      });
      event.target.parentElement.parentElement.classList.add('tab-active');
      let content  = event.target.parentElement.parentElement.parentElement.parentElement.lastElementChild;
      [].forEach.call(content.children, function(el){
      	el.classList.remove("tab-show");
      });
      let id = event.target.parentElement.dataset.target;
      [].forEach.call(content.children, function(el){
        if(el.id == id){
	      	el.classList.add("tab-show");
          	return;
        }
      });
    });
  }); 
});